import moment from 'moment';

import { escapeHtml } from 'Helpers/escapeHtml';

/**
 * The approval-chain tooltip every approval row hangs off its cells.
 *
 * Every approval row draws its chain summary from here rather than rendering
 * its own — a second implementation would be the one that drifts.
 *
 * Returns an HTML string because `Tooltip` renders it through `tooltipContent`,
 * which is how the shipped rows have always fed it.
 */
export const approverTooltipContent = (displayApprovalStatuses) => (data) => {
    if (!data.approvers?.length) {
        return '';
    }

    let result =
        '<table class="p-0 border-0"><thead class="text-dark-blue"><tr>' +
        '<th>Approver</th>' +
        '<th>Status</th>' +
        '<th>Approved At</th>' +
        '<th>Comments</th>' +
        '</tr></thead>' +
        '<tbody>';

    let tooltipRowGbColor = 'bg-grey';
    data.approvers.forEach((item) => {
        result += '<tr class="' + tooltipRowGbColor + '">';
        result += '<td>' + escapeHtml(item.first_name) + ' ' + escapeHtml(item.last_name) + '</td>';
        result += '<td>' + escapeHtml(displayApprovalStatuses[item.pivot.status]) + '</td>';
        result += '<td>' + (item.pivot.approved_at ? moment(item.pivot.approved_at).format('YY-MM-DD') : '-') + '</td>';
        result += '<td>' + escapeHtml(item.pivot.comments) + '</td>';
        result += '</tr>';
        tooltipRowGbColor = tooltipRowGbColor === 'bg-grey' ? '' : 'bg-grey';
    });

    result += '</tbody></table>';

    return result;
};
